import { createSelector } from 'reselect';
import { getLoadingStatuses } from 'helpers/selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getSelectedOrganization = ({ generalFilter }) => {
    return generalFilter?.selectedFilters?.organizations[0];
};

const getGatewayDetails = ({ powertrainTools }) => {
    return powertrainTools?.gateway;
};

const getGatewayType = ({ powertrainTools }) => {
    return powertrainTools?.gatewayType;
};

const getIsModalOpen = ({ powertrainTools }) => {
    return powertrainTools?.gateway?.serialNumberEditorModal?.isModalOpen || false;
};

const getAssignedSerialNumberLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.gateway?.assignSerialNumber?.loadingStatus || null;
};

const getDriveApplications = ({ powertrainTools }) => {
    return powertrainTools?.driveApplications?.data;
};

const getSaveAssetDriveApplicationLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.gateway?.saveAssetDriveApplication?.loadingStatus || null;
};
const getGatewayAssets = ({ powertrainTools }) => {
    return powertrainTools?.gatewayConnectedAssets;
};

const getSelectedGateway = ({ powertrainTools }) => {
    return powertrainTools?.gateway?.selectedGateway;
};

const getDriveApplicationError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.driveApplications?.loadingStatus,
        error: powertrainTools?.driveApplications?.error,
        errorCode: powertrainTools?.driveApplications?.error?.statusCode
    };
};

// Memoized selector for default drive application error data
const getDriveApplicationErrorData = createErrorDataSelector(getDriveApplicationError);

const getGatewayListError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.gateway?.loadingStatus,
        errorCode: powertrainTools?.gateway?.error?.statusCode,
        error: powertrainTools?.gateway?.error
    };
};

// Memoized selector for default gateway list error data
const getGatewayListErrorData = createErrorDataSelector(getGatewayListError);

export const getModel = createSelector(
    [
        getSelectedOrganization,
        getGatewayDetails,
        getGatewayType,
        getIsModalOpen,
        getLoadingStatuses,
        getAssignedSerialNumberLoadingStatus,
        getDriveApplications,
        getSaveAssetDriveApplicationLoadingStatus,
        getGatewayAssets,
        getSelectedGateway,
        getGatewayListErrorData,
        getDriveApplicationErrorData

    ],
    (
        selectedOrganization,
        gatewayDetails,
        gatewayType,
        isModalOpen,
        generalFilterLoadingStatuses,
        assignedSerialNumberLoadingStatus,
        driveApplications,
        saveAssetDriveApplicationLoadingStatus,
        gatewayAssets,
        selectedGateway,
        gatewayListErrorData,
        driveApplicationErrorData

    ) => {
        return {
            selectedOrganization,
            gatewayDetails,
            gatewayType,
            isModalOpen,
            generalFilterLoadingStatuses,
            assignedSerialNumberLoadingStatus,
            driveApplications,
            saveAssetDriveApplicationLoadingStatus,
            gatewayAssets,
            selectedGateway,
            gatewayListErrorData,
            driveApplicationErrorData
        };
    }
);
